module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.js-exposed
// module id = 1294
// module chunks = 4